import { render, staticRenderFns } from "./AdminTags.vue?vue&type=template&id=78755974&scoped=true"
import script from "./AdminTags.vue?vue&type=script&lang=js"
export * from "./AdminTags.vue?vue&type=script&lang=js"
import style0 from "./AdminTags.vue?vue&type=style&index=0&id=78755974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78755974",
  null
  
)

export default component.exports